import { object, number, ref } from "yup";

import { useValidationErrorMessages } from "common/shared/constants/validationErrorMessages";
import { percentageFormatter } from "domains/liquidity/shared/utils/inputValueFormatter";
import { useValidationSchemas } from "common/shared/constants/validationSchemas";

export const useInvestmentDetailsPageValidationSchema = (fromAssetSelection = false, isAlquoteFlow = false) => {
  const { maxNum, positive, required } = useValidationErrorMessages();
  const { capitalCommitmentValidationSchema, currentNetAssetValueValidationSchema } = useValidationSchemas();

  const fieldsRequired = fromAssetSelection || isAlquoteFlow;

  const validationSchema = object().shape({
    current_net_asset_value: fieldsRequired 
      ? currentNetAssetValueValidationSchema.required(required)
      : currentNetAssetValueValidationSchema,
    capital_commitment: fieldsRequired 
      ? capitalCommitmentValidationSchema.required(required)
      : capitalCommitmentValidationSchema,
    unfunded_commitment_currency: number()
      .nullable()
      .when("unfunded_commitment_type", {
        is: "$",
        then: (schema) => {
          const baseSchema = schema.moreThan(-1, positive).max(ref("capital_commitment"), "Can't exceed Capital Commitment's value");
          return fieldsRequired ? baseSchema.required(required) : baseSchema;
        },
      }),
    unfunded_commitment_percentage: number()
      .nullable()
      .when("unfunded_commitment_type", {
        is: "%",
        then: (schema) => schema.positive(positive).max(100, maxNum(percentageFormatter(100))),
      }),
  });

  return { validationSchema };
};
